// B-02: on iOS an attachment opens as a blob window, and a blob document runs in b-mail's
// origin. Only types that can't run script may open that way (PDF, pictures, plain text);
// anything else goes to the server URL, which sends it as a download. Mirrors the inert
// list in backend/src/mail/attachment-type.js, narrowed to what the iOS viewer previews.
export function opensInline(type: string | null | undefined): boolean {
  const t = String(type || '').split(';')[0].trim().toLowerCase();
  return /^application\/(x-)?pdf$/.test(t) || t === 'text/plain' || /^image\/(png|jpeg|jpg|pjpeg|gif|webp|heic|heif|bmp|avif|tiff)$/.test(t);
}
